import React from "react";

export const VoiceOrb = ({ state = "idle", size = 220 }) => {
  const cls =
    state === "speaking" ? "orb-speak" : state === "listening" ? "orb-listen" : "orb-idle";
  return (
    <div
      className="relative flex items-center justify-center"
      style={{ width: size, height: size }}
      data-testid="voice-orb"
      data-orb-state={state}
    >
      <div
        className={`rounded-full ${cls}`}
        style={{
          width: size * 0.72,
          height: size * 0.72,
          background:
            state === "listening"
              ? "radial-gradient(circle at 35% 30%, #7A2230, #2a0d12 70%)"
              : "radial-gradient(circle at 35% 30%, #F3E5AB, #D4AF37 45%, #7a5f13 100%)",
        }}
      />
      <div
        className="absolute rounded-full border border-white/10"
        style={{ width: size, height: size }}
      />
    </div>
  );
};

export default VoiceOrb;
